// Trocar periodicidade (Mensal ⇄ Anual): os dois cards do checkout com os
// preços do plano que vale no próximo ciclo e o aviso de quando e como a
// troca acontece. Escolher o período atual com troca agendada a desfaz.
import React, { useEffect, useState } from "react";
import moment from "moment";

import AerosDialog from "../AerosDialog";
import PeriodCards from "../SubscriptionCheckout/PeriodCards";
import ManageFooter from "./ManageFooter";
import Notice from "./Notice";
import useSubscription from "../../hooks/useSubscription";
import toastError from "../../errors/toastError";
import { i18n } from "../../translate/i18n";
import { avisoTrocaPeriodo } from "./subscriptionCardRules";

const ChangePeriodDialog = ({ open, onClose, subscription, prices, planName, onDone }) => {
  const { patchMe } = useSubscription();
  const vigente = subscription?.pendingPeriod || subscription?.period || "MENSAL";
  const alvo = vigente === "ANUAL" ? "MENSAL" : "ANUAL";
  const [period, setPeriod] = useState(alvo);
  const [saving, setSaving] = useState(false);

  // Só na abertura: recarga do card pelo socket não desfaz a escolha.
  useEffect(() => {
    if (open) setPeriod(prices?.[alvo] ? alvo : vigente);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const periods = prices?.ANUAL ? ["MENSAL", "ANUAL"] : ["MENSAL"];
  const aviso = avisoTrocaPeriodo(subscription, period);
  const semMudanca = period === vigente;

  const handleConfirm = async () => {
    setSaving(true);
    try {
      await patchMe({ action: "changePeriod", period });
      onDone(
        period === subscription.period
          ? i18n.t("subscription.manage.periodUndone")
          : i18n.t("subscription.manage.periodChanged", {
              date: moment(subscription.cycleEnd).format("DD/MM/YYYY"),
            })
      );
    } catch (err) {
      toastError(err);
    } finally {
      setSaving(false);
    }
  };

  return (
    <AerosDialog
      open={open}
      onClose={onClose}
      title={i18n.t("subscription.manage.periodTitle")}
      subtitle={i18n.t("subscription.manage.periodSubtitle", { plan: planName || "" })}
      width={520}
      loading={saving}
      footer={
        <ManageFooter
          cancelLabel={i18n.t("aeros.flow.cancel")}
          onCancel={onClose}
          submitLabel={i18n.t("subscription.manage.periodConfirm")}
          onSubmit={handleConfirm}
          submitDisabled={semMudanca || !aviso}
          loading={saving}
        />
      }
    >
      <PeriodCards
        prices={prices}
        period={period}
        onChange={setPeriod}
        periods={periods}
        cycleStartsToday={subscription?.cycleEnd}
        disabled={saving}
      />
      {aviso && !semMudanca && <Notice live>{aviso}</Notice>}
    </AerosDialog>
  );
};

export default ChangePeriodDialog;
